import { Component, For, Show, createEffect, createMemo, on } from "solid-js";

import CardHeader from "@/components/Base/CardHeader";
import Empty from "@/components/Base/Empty/Index.tsx";
import NotificationCard from "@/components/Base/NotificationCard";
import { SegmentControl } from "@/components/Base/SegmentControl";
import { useNotification } from "@/hooks/useNotification.ts";
import { useI18n } from "@/i18n";
import { sidebarContainerStore } from "@/stores/sidebarContainerStore.ts";

export const Notification: Component = () => {
  const notificationStore = useNotification();
  const { t } = useI18n();
  createEffect(() => {
    notificationStore.initNotification();
  });

  createEffect(
    on(
      createMemo(() => {
        const temp =
          notificationStore?.tabList?.[notificationStore?.pageData?.tabIndex];
        const ids =
          temp?.list
            .filter((item) => item.status === 0)
            .map((item) => item.id) || [];

        return ids;
      }),
      (ids) => {
        if (ids.length) {
          const temp =
            notificationStore?.tabList?.[notificationStore?.pageData?.tabIndex];
          notificationStore.readAllMsgCallback({
            ids: ids,
            msg_type: temp?.list?.[0]?.msg_type,
            read_status: 1,
          });
        }
      },
    ),
  );

  return (
    <>
      <CardHeader
        title={t("notice.notification")}
        class="h-[var(--header-height)] min-h-[var(--header-height)]"
        style={{ "align-items": "center" }}
        closeCallback={sidebarContainerStore.toggleSidebar}
        icon="xx1"
        showClose={true}
      />
      <SegmentControl
        options={notificationStore.tabList.map((item) => ({
          label: item.title,
          value: item.index,
          count: item.count,
        }))}
        value={notificationStore.pageData.tabIndex}
        onChange={(value) => notificationStore.changeTabIndex(value as number)}
        containerClass="bg-general-bg3 rounded-[8px] p-[6px] h-[56px]"
        indicatorClass="bg-general-bg7 rounded-[6px]"
        class="w-full"
        itemClass="text-general-bright flex h-full items-center justify-center px-[15px] text-[14px] font-semibold flex-1"
        activeClass="text-general-light"
        inactiveClass="rounded-[6px] hover:bg-general-bg7 hover:text-general-light"
        listClass="w-full"
      />

      <Show
        when={
          notificationStore?.tabList?.[notificationStore?.pageData?.tabIndex]
            ?.list.length > 0
        }
        fallback={<Empty class="mb-[40px] mt-[246px]" />}
      >
        <div class="grid gap-[12px] overflow-y-auto pb-[70px]">
          <For
            each={
              notificationStore?.tabList?.[
                notificationStore?.pageData?.tabIndex
              ].list
            }
          >
            {(item) => (
              <ul class="h-auto w-full space-y-2">
                <NotificationCard data={item} />
              </ul>
            )}
          </For>
        </div>
      </Show>
    </>
  );
};
